// must use this syntax due to babel not being registered yet or something..
module.exports = require('../../both/helpers/index.js')



// WEBPACK FOOTER //
// ./src/helpers/index.js